import { createAction, props } from '@ngrx/store';
import { Plant } from '../_models';

// Action types
export const loadPlants = createAction('[Plant] Load Plants');
export const loadplantsSuccess = createAction(
  '[Plant] Load Plants Success',
  props<{ plants: Plant[] }>()
);
export const loadplantsFailure = createAction(
  '[Plant] Load Plants Failure',
  props<{ error: any }>()
);

export const addplant = createAction('[Plant] Add Plant', props<{ plant: Plant }>());
export const addplantSuccess = createAction('[Plant] Add Plant Success', props<{ plant: Plant }>());
export const addplantFailure = createAction('[Plant] Add Plant Failure', props<{ error: any }>());

export const updateplant = createAction('[Plant] Update Plant', props<{ plant: Plant }>());
export const updateplantSuccess = createAction(
  '[Plant] Update Plant Success',
  props<{ plant: Plant }>()
);
export const updateplantFailure = createAction(
  '[Plant] Update Plant Failure',
  props<{ error: any }>()
);

export const deleteplant = createAction('[Plant] Delete Plant', props<{ id: number }>());
export const deleteplantSuccess = createAction(
  '[Plant] Delete Plant Success',
  props<{ id: number }>()
);
export const deleteplantFailure = createAction(
  '[Plant] Delete Plant Failure',
  props<{ error: any }>()
);
